import { voteApi, multipartVoteApi } from "./index";

export const getAllVotes = async (credentials) => {
  try {
    const response = await voteApi.post("/Votes/get-all-votes", credentials);
    return response.data;
  } catch (error) {
    throw new Error(error);
  }
};

const staticCache = {
  data: null,
  timestamp: 0
};

export const getAllVotesWithFilters = async (credentials, token, isStatic = false) => {
  // Return cached data if it's a static request and we have data less than 5 minutes old
  if (isStatic && staticCache.data && (Date.now() - staticCache.timestamp < 300000)) {
    console.log('Returning cached static votes');
    return staticCache.data;
  }

  try {
    const response = await voteApi.post("/v2/VotesControllerV/user/get-all-votes", credentials, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'accept': '*/*'
      }
    });

    // Handle the specific API response structure
    const responseData = response.data;
    let finalData = [];
    if (responseData && responseData.success && Array.isArray(responseData.data)) {
      finalData = responseData.data;
    } else if (Array.isArray(responseData)) {
      finalData = responseData;
    } else {
      console.warn('Unexpected API response structure:', responseData);
      finalData = [];
    }

    // Update cache if it's a static request
    if (isStatic) {
      staticCache.data = finalData;
      staticCache.timestamp = Date.now();
    }

    return finalData;
  } catch (error) {
    console.error('Error fetching votes with filters:', error);
    throw new Error(error);
  }
};

export const submitVote = async (credentials) => {
  try {
    const response = await voteApi.post("/UserResponse/submit-vote", credentials);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const viewBallot = async (credentials) => {
  try {
    const response = await voteApi.post("/UserResponse/view-ballot", credentials);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const likeDislike = async (credentials) => {
  try {
    const response = await voteApi.post("/reactions/LikeDislike", credentials);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addComment = async (credentials) => {
  try {
    const response = await multipartVoteApi.post("/comments/add-comment", credentials);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getAllComments = async (voteId) => {
  try {
    const response = await voteApi.get(`/comments/get-comments-by-vote-id?voteId=${voteId}`);
    console.log("response from getAllComments api:", response);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const addBookmark = async (credentials) => {
  try {
    const response = await voteApi.post("/Votes/add-bookmark", credentials);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getAllBookmark = async () => {
  try {
    const response = await voteApi.get("/Votes/get-all-bookmark");
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const deleteBookmark = async (credentials) => {
  try {
    const response = await voteApi.delete("/Votes/delete-bookmark", {
      data: credentials
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getuserVoteHistory = async (userId) => {
  try {
    const response = await voteApi.get(`/UserResponse/get-user-vote-history?userId=${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getVoteDetailsById = async (credentials) => {
  try {
    const response = await voteApi.post("/Votes/get-vote-details-by-id", credentials);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const deleteComment = async (credentials) => {
  try {
    const response = await voteApi.delete("/comments/delete-comment", {
      data: credentials
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}


export const getSubVoteByOption = async (optionId, userId = null) => {
  try {
    let url = `/AIBallotsSaving/get-sub-vote-by-option?OptionId=${optionId}`;
    if (userId) {
      url += `&UserId=${userId}`;
    }
    const response = await voteApi.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching sub-ballot:", error);
    // Return null instead of throwing to allow graceful fallback
    return null;
  }
};

export const getAzureCredentials = async () => {
  try {
    const response = await voteApi.get("/AIBallotsSaving/azure-credentials");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const preparePromptMainBallot = async (payload) => {
  try {
    const response = await voteApi.post("/AIBallotsSaving/prepare-prompt-mainBallot", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const preparePromptSubBallot = async (parentQuestion, options) => {
  try {
    const response = await voteApi.post("/AIBallotsSaving/prepare-prompt-subBallot", {
      parentQuestion: parentQuestion,
      options: options
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const buildValidationPrompt = async (questionTitle, existingOptions, newOption) => {
  try {
    const response = await voteApi.post("/AIBallotsSaving/build-validation-prompt", {
      questionTitle,
      existingOptions,
      newOption
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const saveChatbotHistory = async (payload) => {
  try {
    const response = await voteApi.post("/AIBallotsSaving/save-chatbot-history", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getChatbotHistory = async (userId, sessionId) => {
  try {
    const response = await voteApi.get(`/AIBallotsSaving/get-chatbot-history?userId=${userId}&sessionId=${sessionId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllChatsByUser = async (userId) => {
  try {
    const response = await voteApi.get(`/AIBallotsSaving/get-all-chats-by-user/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMyVotes = async (credentials) => {
  try {
    const response = await voteApi.post("/Votes/get-my-votes", credentials);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSubBallotsByVote = async (voteId, userId) => {
  try {
    const response = await voteApi.get(`/AIBallotsSaving/get-sub-ballots-by-vote/${voteId}/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const clearStaticCache = () => {
  staticCache.data = null;
  staticCache.timestamp = 0;
};
